<template>
  <div>
    <vx-card>
      <vs-table
        :max-items="descriptionItems[0]"
        class="mt-3"
        pagination
        :data="transactions"
        description
        search
        :description-items="descriptionItems"
        description-title="Registries"
        description-connector="of"
        description-body="Pages"
      >
        <template slot="header">
          <!-- ADD NEW -->
        </template>
        <template slot="thead">
          <vs-th>{{ $t("entity.label.transaction_id") }}</vs-th>
          <vs-th>{{ $t("entity.label.transaction_type") }}</vs-th>
          <vs-th>{{ $t("entity.label.amount") }}</vs-th>
          <vs-th>{{ $t("entity.label.transaction_date") }}</vs-th>
          <vs-th>{{ $t("entity.label.category") }}</vs-th>
          <vs-th>{{ $t("entity.label.cancel_remark") }}</vs-th>
          <vs-th class="tHeadCenter">{{ $t("entity.label.actions") }}</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].transactionId">{{
              data[indextr].transactionId
            }}</vs-td>
            <vs-td :data="data[indextr].transactionType">{{
              data[indextr].transactionType
            }}</vs-td>
            <vs-td :data="data[indextr].amount">{{
              data[indextr].creditAmount
            }}</vs-td>
            <vs-td :data="getDate(data[indextr].transDate)">{{
              getDate(data[indextr].transDate)
            }}</vs-td>
            <vs-td :data="data[indextr].transactionCategory">{{
              data[indextr].transactionCategory
            }}</vs-td>
            <vs-td :data="data[indextr].cancelRemark">{{
              data[indextr].cancelRemark
            }}</vs-td>
            <vs-td class="whitespace-no-wrap">
              <div class="container_img">
                <feather-icon
                  v-if="data[indextr].isDeleted === 'N'"
                  title="Payment Reversal"
                  icon="XIcon"
                  class="icon_row"
                  @click="cancelRemarks(data[indextr])"
                  svgClasses="w-5 h-5 stroke-current cursor"
                />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
    <div class="centerx">
      <vs-popup
        class="popup-close"
        :title="$t('entity.label.CancelFinancialTransaction')"
        :active.sync="cancelRemarkPopup"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col mb-2 w-full">
              <small class="date-label font-semibold">{{
                $t("entity.label.cancelremark")
              }}</small>
              <vs-textarea v-model="cancelremark" />
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="cancelRemarkPopup = false">{{
                $t("entity.label.cancel")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="remark">{{
                $t("entity.label.submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import _ from "lodash";
import { mapState } from "vuex";
export default {
  props: ["entityId"],
  data() {
    return {
      descriptionItems: [5, 10, 15],
      cancelremark: "",
      receiptNo: "",
      transactionId: "",
      cancelRemarkPopup: false,
      dateFormat: "dd MMMM yyyy",
    };
  },
  computed: {
    transactions() {
      return this.$store.getters["entity/getTransactions"];
    },
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    getDate(date) {
      if (typeof date == "object") {
        const dateFormat = new Date(date[0], date[1] - 1, date[2]);
        date = dateFormat.toLocaleDateString("en-US");
      }
      return moment(date).format(this.formattedDate);
    },
    cancelRemarks(newValue) {
      if (newValue) {
        this.cancelRemarkPopup = true;
        this.receiptNo = newValue.receiptNo;
        this.transactionId = newValue.transactionId;
      }
    },
    async remark() {
      try {
        const remarkObj = {
          cancelRemark: this.cancelremark,
          receiptNo: this.receiptNo,
          officePoid: 0,
        };
        await this.$store.dispatch("entity/setCancelRemark", {
          id: this.transactionId,
          data: remarkObj,
        });

        this.cancelRemarkPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Financial Transaction Deleted Successfully!",
          type: "success",
        });
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
    async displayTransactions() {
      try {
        this.$store.dispatch("entity/setTransactions", this.entityId);
      } catch (e) {
        this.$toasted.error("something went wrong!");
      }
    },
  },
  mounted() {
    this.displayTransactions();
  },
};
</script>
<style lang="scss" scoped></style>
